import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Table from "react-bootstrap/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
const CohortTypeComponent = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedValue, setSelectedValue] = useState(props.cohortType || ""); // Initialize selectedValue from props

  const cohortTypes = props.seedData.cohort_types || [];

  const filteredOptions = cohortTypes.filter((option) =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleRowClick = (option) => {
    setSelectedValue(option.id); // Update the selectedValue when a row is clicked
    props.handleCohortTypeChange(option.id); // Call parent method to set cohortType in the parent state
  };

  useEffect(() => {
    // When the component mounts or props change, set the selectedValue to reflect the prop value
    setSelectedValue(props.cohortType);
  }, [props.cohortType]);

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <Box>
          <FormControl component="fieldset">
            <p style={styles.label}>
              Cohort Type <span style={{ color: "red" }}>*</span>
            </p>

            {/* Search Field */}
            <TextField
              fullWidth
              id="search-cohort"
              label="Select an option"
              variant="standard"
              value={searchTerm}
              onChange={handleSearchChange}
              sx={{
                "& .MuiInput-underline:before": {
                  borderBottomColor: "#14AE78",
                },
                "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
              }}
            />

            <TableContainer component={Paper} style={styles.tableContainer}>
              <Table stickyHeader>
                <TableBody>
                  {filteredOptions.map((option, index) => (
                    <TableRow
                      key={option.id}
                      hover
                      onClick={() => handleRowClick(option)}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f0f0f0",
                      }}
                    >
                      <TableCell>
                        <FormControlLabel
                          value={option.id}
                          control={
                            <Radio
                              style={styles.radio}
                              checked={selectedValue === option.id} // Ensure the radio is checked if selectedValue matches
                            />
                          }
                          label=""
                        />
                      </TableCell>
                      <TableCell>{option.name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Error Message */}
            {props.errors?.cohortType && (
              <p style={styles.errorMessage}>{props.errors.cohortType}</p>
            )}
          </FormControl>
        </Box>
      </div>
    </div>
  );
};


const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#FFFFFF",
    borderRadius:"24px"

  },
  contentWrapper: {
    width: "60vw",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop:"-168px"
  },
  label: {
    fontSize: "28px",
    fontWeight: 500,
    textAlign: "left",
    marginBottom: "-0px",  
  },
  tableContainer: {
    width: "46vw",
    height: "60vh", 
    overflowY: "auto",
    marginBottom: "15px", 
  },
  radio: {
    color: "#14AE78",
  },
  errorMessage: {
    color: "red",
    textAlign: "left",
    fontSize: "14px",
    marginTop: "10px",  
  },
};

export default CohortTypeComponent;
